var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"4ad69c180224c4ef98665e1e532bfe8bc4f57445"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["marketplace-front-end@vinn-q"]={id:"4ad69c180224c4ef98665e1e532bfe8bc4f57445"};
      